import React from 'react'

import '../App.scss'

import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import MetaTags from '../components/utility/MetaTags'
import Popunder from '../components/ads/Popunder'
import VideoSlider from '../components/ads/VideoSlider'
import Tracking from '../components/utility/Tracking'
import AgeVerification from '../components/AgeVerification'
import Interstitial from '../components/ads/Interstitial'

class Layout extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  componentDidMount() {
    document.body.classList.remove('no-js')

    window.addEventListener('click', this.onClick)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onClick)
  }

  onClick(e) {
    const link = e.target.closest('a')
    if (!link) {
      return
    }

    if (link.getAttribute('target') === '_blank') {
      return
    }

    const href = link.getAttribute('href')
    if (href.includes('/page/') || href === '#') {
      return
    }

    window.scrollTo(0, 0)
  }

  render() {
    const { userAgent } = this.props

    return (
      <React.Fragment>
        <MetaTags />
        <Header />

        <main className="main-section">{this.props.children}</main>

        <Footer />

        <Tracking />
        <Popunder userAgent={userAgent} />
        <VideoSlider userAgent={userAgent} />
        <Interstitial userAgent={userAgent} />
        <AgeVerification />
      </React.Fragment>
    )
  }
}

export default Layout
